import { render, staticRenderFns } from "./InquiryForm.vue?vue&type=template&id=2bd2dad4&"
import script from "./InquiryForm.vue?vue&type=script&lang=ts&"
export * from "./InquiryForm.vue?vue&type=script&lang=ts&"
import style0 from "./InquiryForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VForm,VRow})
